<template>
    <div class="all">
        <analysisHeader ref="child" afromType="1"></analysisHeader>
        <div class="warp mt20">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="uuids.length === pageUuid.length && uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false" @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="isEarlyWarning();">预警</span>
                        <!-- <span class="checkbox-box tion">删除</span> -->
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(7);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                </div>
            </div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <ul class="article-list mtfu24">
                    <li v-for="(item,index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-right fr">
                            <div class="article-btn">
                                <span class="collect" @click="collectFn(index);" :class="item.collectStatus === 0 ? '' : 'curr'"><i class="icons collect-icon"></i></span>
                                <!-- <span class="sign sign-blue">改</span> -->
                                <span class="sign sign-orange cp" :class="item.warningStatus === 0 ? '' : 'gray'" @click="isEarlyWarning(item.warningStatus,item.newsId,item.originNewsTitle);">警</span>
                                <span class="sign sign-blue cp" @click="oneClickCopy(index)">复</span>
                                <span class="sign sign-blue cp" @click="newsPathlist(item.newsSimHash)">溯</span>
                                <!-- <span class="sign sign-red">删</span> -->
                            </div>  
                        </div> 
                        <div class="article-mid">
							<h2 class="article-title clearfix">
								<div class="title ovhidden fl" :class="{difference:item.platform === 'comment'}">
									<span class="tag" :class="$parent.attributeType[item.newsEmotion]">{{item.newsEmotion}}</span>
									<router-link class="color-3d3d4c" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}" v-html="item.newsTitle" :title="item.newsTitle"></router-link>
								</div>
								<div class="fu fl" v-if="item.platform === 'comment'">
									<span class="color-red fs12">评</span>
								</div>
							</h2>
							<p class="ovhidden2 color-8a8a99" :title="item.newsDigest" v-html="item.newsDigest"></p>
                            <p class="ziduan color-8a8a99 mt10">
                                <span>时间：{{item.newsPosttime}}</span>
                                <!-- <span>相似文章：<router-link class="color-blue" target="_blank" :to="{path:''+$parent.baseUrl+'/similarArticles',query: {id:item.newsId}}" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</router-link></span> -->
                                <span>相似文章：<i class="color-blue" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</i></span>
                                <span>发布平台：<i class="icons sm-icon" :class="icons[item.platform]"></i>{{item.platformName}}</span>
                                <span>发布人：{{item.mediaName}}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{item.mediaProvince}}</span>
                                <span>分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{item.keywords}}</span>
                                <!-- <span v-if="item.mediaLevel != ''">媒体等级：{{item.mediaLevel}}</span> -->
                            </p>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <!-- <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page> -->
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix">
                    <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{downloadTips}}</span></h4>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 一键复制 -->
		<copy ref="copy" :text="copyHtml"></copy>
        <tracingTheSource :postData="postData"></tracingTheSource>
	</div>
</template>
<script>
import {mapState} from 'vuex';
import Dialog from '../../../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import tracingTheSource from '../components/tracingTheSource.vue'
import city from '../../../components/city.vue';
import page from '../../../components/page.vue';
import copy from '../../../components/copy.vue';
import analysisHeader from './analysisHeader.vue';
export default {
    components:{VueDatepickerLocal,city,page,Dialog,copy,analysisHeader,tracingTheSource},
    computed:{
        ...mapState({
            showData: state => state.show.showData
        })
    },
    watch:{
        platformType:{
            handler(newVal,oldVal){
                this.dataAjax();
            }
        }
    },
    data() {
        const min = ''
        const max = ''
        return {
            copyHtml:'',
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            pageData:[],//页面链接所有参数
            downloadTips:'',//全部下载提示
			selectOption:[],
            selectOptionValue:[],//已选择下载
            newsId:'',//新闻id
            page:1,//页码
            limit:20,//每页显示条数
            newsSimHash:'',
            totalCount:'',//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//选择的newsid数组
            planId:'',//方案ID
            planName:'',//方案ID
            newsList:[],//新闻列表
            watch:true,//是否监听
            title:'',//标题
            downLoadType:'',//下载类型
            nodata:false,//暂无数据
            // 舆情总览政府和主流报道列表的少选参数
            timeRange:[],
            mediaType:'',//媒体类型
            timeType:0,//时间乐类型
            mediaDist:[],//媒体列表
            mediaLevel:'',//选择的媒体
            keywords:'',
            searchPlaceholder:['信息标题/内容/来源查询','请输入信息标题查询','请输入信息内容查询','请输入媒体来源查询'],//搜索提示语
            searchText:['全部','标题','内容','来源'],
            searchType:0,//搜素是的分类
            emotionList:['正面','中性','负面'],//情感字段
            emotion:['正面','中性','负面'],
            startDate:'',
            endDate:'',
            platformType:'',
            postData:{}//文章追溯数据
        }
    },
    mounted() {
        let that = this;
        this.endDate_ = this.$route.query.endTime;
		that.$nextTick(()=> {
            that.planId = that.$refs.child.planId;
            //数据加载
            that.dataAjax();
        })
    },
    created() {
        // 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
        this.planName = JSON.parse(sessionStorage.getItem('planStorage')).name;
    },
    methods: {
        // 获取新闻列表
        getNewsList () {
            let that = this;
            let datas = {
                sid:that.planId,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType===''?'total':that.platformType,
                pubArea:that.pubArea,
                startDate:that.startDate,
                endDate:that.endDate_!==null?that.endDate_:that.endDate,
                isFocus:that.$refs.child.source
            };
            that.uuids = [];
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/info/hot-article', datas, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    if(data.length <= 0){//没有数据
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
                    that.newsList = data;//新闻列表赋值 
                    let pageUuid = [];
                    for(let i of data){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    // 调用获取分析词和相似文章
                    that.getSimilarArticle(data);
                });
            })
        },
        // 获取分析词和相似文章
        getSimilarArticle (data) {
            let that = this;
            if(data.length <= 0){
                return;
            }
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            for(let i of data){
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
			let datas = {
			    mediaLevel:that.mediaLevel,
                platformType:that.platformType===''?'total':that.platformType,
                pubArea:that.pubArea,
                startDate:that.startDate,
                endDate:that.endDate_!==null?that.endDate_:that.endDate,
                isFocus:that.$refs.child.source
            };
            that.$api.post('monitor/info/news-simnum', {sid:that.planId,simHash:simHash,newsId:newsIds,data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.simNum = datas[j].simNum;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
            that.$api.post('monitor/info/news-keyword', {postDate:postDate,newsId:newsIds}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let checked = e.target.checked;
            that.uuids = [];
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        // 下载
        downLoad (type) {
            let that = this;
            that.downLoadType = type;
			that.selectOptionValue = ['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_pubArea','news_posttime','media_pubArea'];
            let uuid = '';//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的文章');
                    return;
                }
            }else{
                if(that.newsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
			let data = {
			    uuid:uuid,
			    field:that.selectOptionValue,
			    searchWords:'',
                mediaLevel:that.mediaLevel,
                emotion:'',
			    platformType:that.platformType===''?'total':that.platformType,
			    pubArea:that.pubArea,
			    startDate:that.startDate,
				isFocus:that.$refs.child.source,
			    endDate:that.endDate_!==null?that.endDate_:that.endDate,
			};
			that.$parent.loadModal(true,'正在获取数据...');
			that.$api.post('monitor/info/download-before', {type:type,sid:that.planId,data:data}, r => {
			    that.$utils.returnCode(r,function(){
			        that.$parent.showLoad = false;
			        that.downloadTips = r.msg;
					that.selectOption = r.data.fieldList;
			        that.$refs.downloadOption.showMaskFun();
			    });
			})
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            if(that.selectOptionValue.length <= 0){
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = '';//全部下载为空
            let type = that.downLoadType;
            if(type === 1){//选择下载
                uuid = that.uuids;
            }
            let data = {
                uuid:uuid,
                field:that.selectOptionValue,
                mediaLevel:that.mediaLevel,
                platformType:that.platformType===''?'total':that.platformType,
                pubArea:that.pubArea,
                startDate:that.startDate,
				isFocus:that.$refs.child.source,
                endDate:that.endDate_!==null?that.endDate_:that.endDate,
            };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/info/download', {type:type,sid:that.planId,data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.selectOptionValue = [];
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                });
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList(1);
        },
        //收藏
        collectFn (index) {
            let that = this;
            let newsList = that.newsList;
            let sc = newsList[index].collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let uUid = newsList[index].newsId;
            let data = {
                type:1,
                typeId:[uUid]
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    sc = sc === 0 ? 1 : 0;
                    newsList[index].collectStatus = sc;
                    that.$utils.alertText('操作成功');
                });
            })
        },
        // 是否预警
        isEarlyWarning (type,id,title){
            let that = this;
            if(id === undefined){
                title = '是否发送人工预警？'
            }
            if(type === 0){//预警
                that.$confirm(title,'发送预警').then(() => {
                    that.earlyWarning(id,type)
                }) 
            }else{//取消
                that.earlyWarning(id,type)
            }
        },
        // 预警
        earlyWarning (id,type) {
            let that = this;
            let isSupportArtificialWarningSet = that.$parent.isSupportArtificialWarningSet;//检测预警功能
            if(isSupportArtificialWarningSet != 1){
                that.$parent.alertTips('对不起，你暂无使用预警功能的权限！');
                return;
            }
            let uuid = '';
            let url = '';
            if(id === undefined){//批量预警
                url = 'monitor/warning/artificial-create';
                uuid = that.uuids;
            }else{
                uuid = [id];
            }
            if(type === 0){//添加预警
                url = 'monitor/warning/artificial-create';
            }else if(type === 1){//取消预警
                url = 'monitor/warning/artificial-delete';
            }
            if(uuid.length <= 0){
                that.$utils.alertText('请选择需要预警的新闻');
                return;
            }
            let datas = {
                sid:that.planId,
                newsId:uuid
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let newsList = that.newsList;
                    for(let i of uuid){
                        for(let j of newsList){
                            if(i === j.newsId){
                                if(type === 1){//取消
                                    j.warningStatus = 0;
                                }else{//预警
                                    j.warningStatus = 1;
                                }
                            }
                        }
                    }
                    that.$utils.alertText('操作成功');
                });
            })
        },
		// 一键复制
		oneClickCopy (index){
			let that = this;
            let list = that.newsList[index];
            this.copyHtml = '';
            let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
            for(let i in copyFields){
                this.copyHtml += copyFields[i]+':'+list[i]+'\n'
            }
			// this.copyHtml = '标题: '+list.originNewsTitle+'\n链接: '+list.newsUrl+'\n时间: '+list.newsPosttime+'\n来源:'+list.platformName+'\n作者: '+list.mediaName+'\n情感属性: '+list.newsEmotion+'\n分析词: '+list.keywords+'';
        },
        // 舆情总览政府和主流报道列表的特殊方案
        // 固定时间选择
        selectFixedTime (type) {//0是今天 1是昨天 2是近三天 3是近7天 4是自定义
            let that = this;
            that.dynamicTime(type);
            that.getMediaLevel();
        },
        // 动态获取时间
		dynamicTime (type){
			let that = this;
			let nowTime = this.$utils.getNowDate();//今天时间
			let n = nowTime.split(' ')[1].split(':');//拆分当前时分秒
			let h = n[0]; 
			let m = n[1]; 
			let s = n[2]; 
			let min = '';
			let max = '';
			that.timeType = type;
			if(type != 4){//非自定义
			    if(type === 0){
			        min = nowTime.split(' ')[0] + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 1){
			        let yesterday = this.$utils.getBeforeDay(nowTime,1);//前一天
			        min = yesterday + ' ' + '00:00:00';
			        max = yesterday + ' ' + '23:59:59';
			    }else if(type === 2){
			        let ptd = this.$utils.getBeforeDay(nowTime,3);//前三天
			        // min = ptd + ' ' + h + ':' + m + ':' + s;
			        min = ptd + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 3){
			        let psd = this.$utils.getBeforeDay(nowTime,7);//前七天
			        // min = psd + ' ' + h + ':' + m + ':' + s;
			        min = psd + ' ' + '00:00:00';
			        max = nowTime;
			    }else if(type === 5){
			        let psd = this.$utils.getBeforeDay(nowTime,1);//24小时
			        min = psd + ' ' + h + ':' + m + ':' + s;
			        max = nowTime;
			    }else if(type === 6){
			        let day = JSON.parse(sessionStorage.getItem('planStorage')).adjustDay;
			        that.initialTime(day);
					return;
			    }
			    //进页面获取时间数据
			    that.startDate = min
                that.endDate = max;
			}else{
			    // let day = JSON.parse(sessionStorage.getItem('planStorage')).day;
			    that.initialTime(7);	
			}
        },
        // 获取当前时间和7天前时间
        initialTime(day) {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,day);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);	
            this.endDate = this.$utils.dateConversion(max,1);
        },
        // 媒体类别数据
        getMediaLevel (){
            let that = this;
            let datas = {
                sid:that.planId,
                startDate:that.startDate,
                endDate:that.endDate_!==null?that.endDate_:that.endDate,
                searchWords:that.keywords,
                type:that.$route.query.type,
                searchType:that.searchType,
                emotion:that.emotion
            };
            that.$api.get('monitor/news-list/media-level',datas,r =>{
                that.$utils.returnCode(r,function(){
                    that.mediaDist = r.data;
                    that.getNewsList(0);
                });
            })
        },
        // 选择搜索分类
        searchSelect (value) {
            this.searchType = value;
        },
        // enter键搜索
        KeyUpEsc () {
            this.getMediaLevel();
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
        },
        //选择时间回调
        selectedDate () {
            let that = this;
            that.watch = false;
            that.startDate = this.$utils.dateConversion(this.timeRange[0],1);
            that.endDate = this.$utils.dateConversion(this.timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startDate,that.endDate);
            if(day > that.$parent.timeSection){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
                return;
            }
            that.getMediaLevel();
        },
        dataAjax(){
            let that = this;
            //热点事件
            that.getNewsList();
        },
        // 文章追溯
        newsPathlist (simHash){
            this.postData = {
                simHash:simHash,
                sid:this.planId
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/propagationAnalysis/hotarticlesDetail.vue